import moment from 'moment'

export default {
  obfuscateString (str) {
    if (typeof str === 'string') {
      const strObfuscado = str.substring(0, 3) + '***********' + str.substring(str.length - 3, str.length)

      return strObfuscado
    }

    return ''
  },

  hideCustomerData (customer) {
    const { holder } = customer
    const holderOfuscado = this.obfuscateString(holder)

    const customerObfuscated = {
      ...customer,
      holder: holderOfuscado
    }

    return customerObfuscated
  },

  removeCustomerSensitiveData (customer) {
    const customerLGPD = this.hideCustomerData(customer)
    const { _id, _rev, holder, uc, contemplated, collection, createdAt, cadastroOnline } = customerLGPD
    const customerObfuscated = {
      _id,
      _rev,
      uc,
      holder,
      contemplated,
      collection,
      cadastroOnline,
      createdAt,
      updatedAt: moment().format('YYYY/MM/DD hh:mm:ss')
    }

    return customerObfuscated
  }
}



// WEBPACK FOOTER //
// ./src/services/LGPD.js